export default {
  namespaced: true,

  state: () => ({
    /**
     * Объект со списком фич, где ключом является идентификатор фичи,
     * а значением при ключе - её статус (включена/отключена)
     * @type {Object}
     */
    $features: {},
  }),

  getters: {
    /**
     * Проверяет, включена ли фича с указанным идентификатором
     * @param {Object} state
     * @param {string} featureId Идентификатор фичи
     * @return {boolean}
     */
    $isFeatureEnabled: (state) => (featureId) => !!state?.$features?.[featureId],
  },
};
